import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AlertType, ButtonType, ButtonVariant, DrawerComponent, IconName } from '@yupma/ui-kit';
import { EntityAddFormField, EntityType, EntityViewDocument, FieldDocument, FieldGroupDocument, FieldType } from 'server-model';
import { EntityConfigurationDataService, IAMService, UIService } from 'src/app/services/services.module';

class DisaplayEntityViewFields {
  constructor(
    public field_name: string,
    public label: string, // Additional property
    public field_type: FieldType | null, // Additional property
    public is_editable: boolean = true,
  ) { }
}

@Component({
  selector: 'app-customize-entity-view-drawer',
  templateUrl: './customize-entity-view-drawer.component.html',
  styleUrl: './customize-entity-view-drawer.component.scss'
})
export class CustomizeEntityViewDrawerComponent implements OnInit {
  @ViewChild(DrawerComponent) drawerComponent!: DrawerComponent;
  @Input() allFields: FieldDocument[] = []
  @Input() allGroups: FieldGroupDocument[] = []
  @Input() entityView: EntityViewDocument | null = null;
  @Output() onClose = new EventEmitter();
  showDrawer: boolean = true;
  buttonTypes = ButtonType;
  buttonVariants = ButtonVariant;
  iconNames = IconName;
  entityViewFields: EntityAddFormField[] = [];
  disaplayEntityViewFields: DisaplayEntityViewFields[] = [];
  // isRequiredError: boolean = false;
  // requiredFields: string = '';
  // uniqueValueFieldNames: string[] = [];
  isLoading: boolean = false;
  // alertTypes = AlertType;
  disabledFields = ['email', 'first_name', 'last_name', 'contact_owner']

  constructor(
    private iamService: IAMService,
    private entityConfigurationDataService: EntityConfigurationDataService,
    private uiService: UIService,
  ) { }

  async ngOnInit() {
    try {
      if (this.entityView) {
        // const organisationId = this.iamService.getOrganisationId();
        // this.entityView = new EntityViewDocument(organisationId, EntityType.CONTACT, [])
        // this.entityView = await this.entityConfigurationDataService.getEntityView(organisationId, EntityType.CONTACT);
        this.entityViewFields = this.convertToEntityAddFormArray(this.entityView.fields);
        this.updateEntityViewFields(this.entityViewFields);
        // const uniqueValueFieldsLabel: string[] = [];
        // this.allFields.map((field) => {
        //   if (field.has_unique_value) {
        //     uniqueValueFieldsLabel.push(field.label);
        //     this.uniqueValueFieldNames.push(field.name);
        //   }
        // })
        // this.requiredFields = uniqueValueFieldsLabel.join(', ');
      }
    } catch (error) {
      console.log(error)
    }
  }

  toggleDrawer() {
    this.showDrawer = !this.showDrawer
    if (!this.showDrawer) {
      this.onClose.emit();
    }
  }

  updateEntityViewFields(fields: EntityAddFormField[]) {
    this.entityViewFields = fields;
    this.disaplayEntityViewFields = fields
      .map(entityField => {
        // Find the corresponding field document
        const matchingFieldDocument = this.allFields.find(field => field.name === entityField.field_name && !field.is_archived);

        if (!matchingFieldDocument) {
          console.warn(`No matching field found for field_name: ${entityField}`);
          return null; // Return null for unmatched fields
        }

        // Create a DisaplayEntityViewFields object
        return new DisaplayEntityViewFields(
          entityField.field_name,
          matchingFieldDocument.label,
          matchingFieldDocument.field_type,
          entityField.is_editable,
        );
      })
      .filter((field): field is DisaplayEntityViewFields => field !== null); // Filter out null values
  }


  removeField(field: DisaplayEntityViewFields) {
    // Remove the field from disaplayEntityViewFields
    this.disaplayEntityViewFields = this.disaplayEntityViewFields.filter(f => f.field_name !== field.field_name);

    // Remove the field from entityViewFields
    this.entityViewFields = this.entityViewFields.filter(f => f.field_name !== field.field_name);
  }

  convertToStringArray(fields: EntityAddFormField[]): string[] {
    return fields.map(field => field.field_name);
  }

  convertToEntityAddFormArray(fields: string[]): EntityAddFormField[] {
    return fields.map((fieldName, index) => new EntityAddFormField(index + 1, fieldName, false, !this.entityView?.disabled_fields.includes(fieldName),));
  }

  async saveEntityAddForm() {
    try {
      if (this.entityView) {
        this.entityView.fields = this.convertToStringArray(this.entityViewFields);
        // if (!this.checkFieldsRequirement()) {
        //   return this.isRequiredError = true;
        // }
        this.isLoading = true;
        const organisationId = this.iamService.getOrganisationId();
        // const entityAddFormView = new EntityAddFormDocument(organisationId, EntityType.CONTACT, [])

        await this.entityConfigurationDataService.updateEntityView(organisationId, EntityType.CONTACT, this.entityView);
        this.uiService.showToast('Updated successfully');
        this.isLoading = false;
        this.drawerComponent.closeDrawer();
      }
      return true
    } catch (error) {
      this.isLoading = false;
      console.log(error)
      return false
    }
  }

  // checkFieldsRequirement() {
  //   // Check if any field in entityViewFields with a name in uniqueValueFieldNames is required
  //   const hasRequiredUniqueValueField = this.entityViewFields.some(field =>
  //     this.uniqueValueFieldNames.includes(field.field_name)
  //   );

  //   // Set the error flag based on the result
  //   return hasRequiredUniqueValueField;
  // }


  drop(event: CdkDragDrop<DisaplayEntityViewFields[]>) {
    moveItemInArray(this.disaplayEntityViewFields, event.previousIndex, event.currentIndex);

    // Identify the moved field from disaplayEntityViewFields
    const movedField = this.disaplayEntityViewFields[event.currentIndex];

    // Find its index in entityViewFields
    const addFieldIndex = this.entityViewFields.findIndex(f => f.field_name === movedField.field_name);

    if (addFieldIndex !== -1) {
      // Move the same field within entityViewFields
      moveItemInArray(this.entityViewFields, addFieldIndex, event.currentIndex);
    }
  }


}
